import { type FC } from 'react'
import { useEMoneyContactSync } from '../IntegrationSpecificSettings/eMoney/hooks'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

export const EMoneyCrmSettingsProvider: FC<CrmSettingsProviderProps> = ({ children }) => {
  const contact = useEMoneyContactSync()

  const settings: CrmIntegrationSettings = {
    contactSync: contact.autoSync,
    calendarSync: false,
    isSyncDisabled: false,
    isFetching: contact.isFetching,
    isSaving: contact.isSaving,
    save: async (patch) => {
      if (patch.contactSync !== undefined) {
        await contact.saveAutoSync(patch.contactSync)
      }
    },
  }

  return <>{children(settings)}</>
}
